import { VehiculoModel } from './vehiculo.model';

export class UsuarioAutorizadoVehiculoModel {

    nif: string;
    vehiculo: VehiculoModel;

    constructor() {
      this.nif = '';
      this.vehiculo = new VehiculoModel();
    }

}
